import { render, staticRenderFns } from "./addInPrivacyPolicy.vue?vue&type=template&id=a629149a&"
import script from "./addInPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./addInPrivacyPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports